module.exports = __webpack_public_path__ + "static/media/sleep.c32d6f1c.jpg";